import { Modal } from 'antd'

/**
 * 重複儲值確認
 *
 * 後端在同一位客人 120 秒內已有一筆「入帳金額相同」的儲值時，會回
 * 409 + code 'DUPLICATE_TOPUP'（規則見 beauty-server/utils/duplicateTopupGuard.js）。
 * 這不是錯誤而是「請店家確認一次」：客人真的要連續儲值兩次時，
 * 按「確定再儲值」就會帶 confirmDuplicate: true 重送並放行。
 *
 * 注意與 idempotency 中介層的 409（code 'DUPLICATE_REQUEST'）區分：
 * 那個是同一個請求被重送，不應該讓店家確認後再送。
 */
export const DUPLICATE_TOPUP_CODE = 'DUPLICATE_TOPUP'

export const isDuplicateTopupError = (err) =>
  err?.response?.status === 409 &&
  err?.response?.data?.code === DUPLICATE_TOPUP_CODE

export const confirmDuplicateTopup = (err) =>
  new Promise((resolve) => {
    Modal.confirm({
      title: '可能重複儲值',
      content:
        err?.response?.data?.error ||
        '剛剛已為此客戶儲值相同金額，是否確定要再次儲值？',
      okText: '確定再儲值',
      cancelText: '取消',
      okButtonProps: { danger: true },
      onOk: () => resolve(true),
      onCancel: () => resolve(false)
    })
  })

/**
 * 送出儲值請求；遇到重複儲值的 409 先請店家確認，確認後帶 confirmDuplicate 重送。
 * @returns {Promise<import('axios').AxiosResponse|null>} 店家取消時回傳 null
 */
export async function postTopupWithDuplicateConfirm (api, url, data) {
  try {
    return await api.post(url, data)
  } catch (err) {
    if (!isDuplicateTopupError(err)) throw err
    const confirmed = await confirmDuplicateTopup(err)
    if (!confirmed) return null
    return api.post(url, { ...data, confirmDuplicate: true })
  }
}
